import { createGlobalStyle } from 'styled-components';
import { reset } from 'styled-reset';
import { theme } from 'styles/theme';

const GlobalStyle = createGlobalStyle`
  ${reset}

  html {
    /* desktop~ */
    font-size: 95%;
   @media screen and ${theme.device.desktop} {
      /* tablet~desktop 
      font-size: 90%;
    }*/
    @media screen and ${theme.device.tablet} {
     /* mobile~tablet */
      font-size: 75%;
    }
    @media screen and ${theme.device.mobile} {
      /* mobileMini~mobile */
      font-size: 62.5%;
    }
    @media screen and ${theme.device.mobileMini} {
      /* mobileMini~ */
      font-size: 40%;
    }
  }

  @keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@font-face {
    font-family: 'SeoulNamsanC';
    font-weight: 300;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCLight.eot');
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCLight.eot?#iefix') format('embedded-opentype'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCLight.woff2') format('woff2'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCLight.woff') format('woff'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCLight.ttf') format("truetype");
    font-display: swap;
}
@font-face {
    font-family: 'SeoulNamsanC';
    font-weight: 500;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCMedium.eot');
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCMedium.eot?#iefix') format('embedded-opentype'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCMedium.woff2') format('woff2'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCMedium.woff') format('woff'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCMedium.ttf') format("truetype");
    font-display: swap;
}
@font-face {
    font-family: 'SeoulNamsanC';
    font-weight: 700;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBold.eot');
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBold.eot?#iefix') format('embedded-opentype'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBold.woff2') format('woff2'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBold.woff') format('woff'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBold.ttf') format("truetype");
    font-display: swap;
}
@font-face {
    font-family: 'SeoulNamsanC';
    font-weight: 800;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCExtraBold.eot');
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCExtraBold.eot?#iefix') format('embedded-opentype'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCExtraBold.woff2') format('woff2'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCExtraBold.woff') format('woff'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCExtraBold.ttf') format("truetype");
    font-display: swap;
}
@font-face {
    font-family: 'SeoulNamsanC';
    font-weight: 900;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBlack.eot');
    src: url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBlack.eot?#iefix') format('embedded-opentype'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBlack.woff2') format('woff2'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBlack.woff') format('woff'),
        url('https://cdn.jsdelivr.net/gh/webfontworld/seoulnamsan/SeoulNamsanCBlack.ttf') format("truetype");
    font-display: swap;
}

* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;      
  }
  
  body {
    font-size: 14px;
    line-height: 1.43;
    background-color: #fff;    
    font-family: 'SeoulNamsanC', sans-serif;
    /* letter-spacing: -0.8px; */
  }
  
  a, a:hover, a:focus {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  input, button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }

  ol, ul, li {
    /* list-style: none; */
  }
  img {
    width: 100%;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /* -webkit-touch-callout: none; */
    -webkit-touch-callout: none !important;
  }
`;

export default GlobalStyle;
